var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccountStarOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0C12.0456 0 12.8087 0.31607 13.3713 0.87868C13.9339 1.44129 14.25 2.20435 14.25 3C14.25 3.79565 13.9339 4.55871 13.3713 5.12132C12.8087 5.68393 12.0456 6 11.25 6C10.4544 6 9.69129 5.68393 9.12868 5.12132C8.56607 4.55871 8.25 3.79565 8.25 3C8.25 2.20435 8.56607 1.44129 9.12868 0.87868C9.69129 0.31607 10.4544 0 11.25 0ZM11.25 1.425C10.8323 1.425 10.4317 1.59094 10.1363 1.88631C9.84094 2.18168 9.675 2.58228 9.675 3C9.675 3.41772 9.84094 3.81832 10.1363 4.11369C10.4317 4.40906 10.8323 4.575 11.25 4.575C12.12 4.575 12.825 3.87 12.825 3C12.825 2.13 12.12 1.425 11.25 1.425ZM11.25 6.75C13.2525 6.75 17.25 7.7475 17.25 9.75V12H5.25V9.75C5.25 7.7475 9.2475 6.75 11.25 6.75ZM11.25 8.175C9 8.175 6.675 9.27 6.675 9.75V10.575H15.825V9.75C15.825 9.27 13.4775 8.175 11.25 8.175ZM3.75 6.96L1.875 8.0775L2.385 5.97L0.75 4.56L2.9025 4.3725L3.75 2.3925L4.5825 4.3725L6.75 4.56L5.1 5.97L5.5875 8.0775L3.75 6.96Z",
    fill: "#6C757D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountStarOutline);
export default __webpack_public_path__ + "static/media/AccountStarOutline.2f3a4e66.svg";
export { ForwardRef as ReactComponent };